import { useQuery } from '@tanstack/react-query';
import { AirtableService } from '../../shared/airtable';

const Airtable = new AirtableService(
  process.env.REACT_APP_AIRTABLE_API_KEY || '',
);

interface UseBaseTableRecordsProps {
  baseId: string | null;
  tableId: string | null;
  filterByFormula?: string;
  offset?: string;
  pageSize?: number;
  enabled?: boolean;
}

const useBaseTableRecordsQuery = ({
  baseId,
  tableId,
  filterByFormula,
  offset,
  pageSize,
  enabled = true,
}: UseBaseTableRecordsProps) => {
  const { data, isLoading, error, isError, isFetching, refetch } = useQuery({
    queryKey: [
      'base-tables',
      { baseId, tableId, filterByFormula, offset, pageSize },
    ],
    queryFn: () =>
      Airtable.getTableRecords(
        baseId || '',
        tableId || '',
        filterByFormula,
        offset,
        pageSize,
      ),
    retry: false,
    enabled: !!baseId && !!tableId && enabled,
  });

  return {
    isLoading,
    isError,
    isFetching,
    error,
    data,
    refetch,
  };
};

export default useBaseTableRecordsQuery;
